// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.return-modal{ font-size: 16px;\n}\n.to-be-payed{ background: var(--blue-light-bg);\n}\n.cashdro-screen{ display: block; width: 100%; height: 75vh; border: 1px solid var(--border-color, #ddd); border-radius: 3px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
